import React from 'react';
import Title from '../components/common/title/Title';
import Dashboard from '../components/dashboard/Dashboard';

const DashboardPage = () => {
  return (
    <>
      <Title text="대시보드" />
      <Dashboard />
    </>
  );
};

export default DashboardPage;
